import { useState, useCallback } from "react";
import {
  getDeletedWitnessURL,
  putRecoverWitnessURL,
} from "../../utils/ConstantsURL";
import { toastAlert } from "../../utils/AlertContext";

export const useRecoverWitness = (token, id_documento, fecha) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const normalizeWitnesses = useCallback((data) => {
    return data.map((item) => ({
      id: item.ID_REFERENCIA,
      title: item.TITULO || "Sin título",
      content: item.FUENTE || "Sin contenido",
      deletedAt: item.FECHA,
      medio: item.MEDIO || "Sin medio",
    }));
  }, []);

  const getDeletedWitness = useCallback(async () => {
    try {
      setLoading(true);
      const url = getDeletedWitnessURL(id_documento, fecha);
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const rawData = await response.json();
      const normalizedData = normalizeWitnesses(rawData);

      return normalizedData;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  },[token, id_documento, fecha, normalizeWitnesses]);

  const putRecoverWitness = useCallback( async (id_referencia) => {
    try {
      setLoading(true);
      const url = putRecoverWitnessURL();

      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ id_referencia }),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Error en PUT /recover-witness: ${errorText}`);
      }

      const result = await response.json();
      toastAlert("Testigo restaurado correctamente", "success");
      return result;
    } catch (err) {
      console.error(
        "[useRecoverWitness] Error al restaurar testigo:",
        err.message
      );
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [token]);

  return {
    getDeletedWitness,
    putRecoverWitness,
    loading,
    error,
  };
};
